import {ApplicationRef, Component, Inject, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {PhotoType} from "../../../models/photoDataPhotoType";
import {SurveyPhoto} from "../../../models/surveyScheme/field";
import {Lightbox, LIGHTBOX_EVENT, LightboxEvent} from "angular2-lightbox";
import * as _ from "lodash";
import { saveAs } from "file-saver";
import {Observable, Subscription} from "rxjs";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import {FileStorageService} from "../../../services/fileStorage.service";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-photoListSurveyField',
  templateUrl: './photoListSurveyField.component.html',
  styleUrls: ['./photoListSurveyField.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PhotoListSurveyFieldComponent implements OnInit {

  @Input() taskId: number
  @Input() sectionNumber: number;
  @Input() tupleNumber?: number = null;
  @Input() fieldNumber: number;
  @Input() surveyPhotos: SurveyPhoto[];

  private _photos: Array<any> = [];
  private _fileUrls: { [fileId: string]: Observable<SafeUrl> } = {};
  private _subscriptionLightBox: Subscription;
  private _showingImageCount: number = 3;

  constructor(
    private _lightbox: Lightbox,
    private _fileStorage: FileStorageService,
    private _domSanitizer: DomSanitizer,
    private _lightboxEvent: LightboxEvent,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
  }


  private _onReceivedLightBoxEvent(event: any): void {
    if (event.id === LIGHTBOX_EVENT.CLOSE) {
      this._subscriptionLightBox.unsubscribe();
    }

    if (event.id === LIGHTBOX_EVENT.CHANGE_PAGE) {
      this.addDownloadButtonToLightbox(event.data, false);
    }
  }

  private getPhoto(blobServiceFileName: string, type: PhotoType): Observable<any> {
    let url = this._fileUrls[blobServiceFileName];

    if (url == null) {
      url = this._fileStorage.getPhotoFile(blobServiceFileName, type)
        .map(e => {
          let resourceUrl = this._domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(e))

          this._photos.push({
            src: resourceUrl,
            caption: null,
            thumb: null,
            fileId: blobServiceFileName,
            type: type
          });

          return resourceUrl;
        })

      this._fileUrls[blobServiceFileName] = url;
    }

    return url;
  }

  private openPhoto(blobServiceFileName: string): void {
    this._subscriptionLightBox = this._lightboxEvent.lightboxEvent$
      .subscribe(event => this._onReceivedLightBoxEvent(event));


    if (this._photos.length != this.surveyPhotos.length) {
      let getPhotoObservables = this.surveyPhotos.slice(this._showingImageCount + 1).map(photo => {
        return this.getPhoto(photo.blobServiceFileName, photo.type);
      });

      Observable.concat(...getPhotoObservables).subscribe();
    }

    let index = _.findIndex(this._photos, { fileId: blobServiceFileName });

    this._lightbox.open(this._photos, index);
    this.addDownloadButtonToLightbox(index, true);
  }

  private downloadPhoto(blobServiceFileName: string, type: PhotoType, photoNumber: number): Observable<Blob> {
    if (blobServiceFileName == null || type == null)
      return null;

    this._fileStorage
      .getPhotoFile(blobServiceFileName, type)
      .subscribe(result => saveAs(result, `Анкета_${this.taskId}_${this.sectionNumber}_` +
      `${this.tupleNumber != null ? `${this.tupleNumber}_` : ''}${this.fieldNumber}_${photoNumber}`));
  }

  private downloadArchive(): Observable<Blob> {
    if (this.taskId == null || this.sectionNumber == null || this.fieldNumber == null)
      return null;

    this._fileStorage
      .getSurveyFieldPhotoArchive(this.taskId, this.sectionNumber, this.fieldNumber, this.tupleNumber)
      .subscribe(result => saveAs(result, `Анкета_${this.taskId}_${this.sectionNumber}_` +
      `${this.tupleNumber != null ? `${this.tupleNumber}_` : ''}${this.fieldNumber}`));
  }

  private addDownloadButtonToLightbox(photoIndex: number, createElement: boolean): void {
    const downloadButtonFromLightboxClassName = "lb-download";
    const newElement: Element = this.document.createElement("span");
    newElement.className = downloadButtonFromLightboxClassName;
    newElement.innerHTML = "<i class=\"material-icons\">download</i>";
    newElement.addEventListener("click", () => {
      let photo = this._photos[photoIndex];
      this.downloadPhoto(photo.fileId, photo.type, photoIndex + 1);
    });

    setTimeout(() => {
      const buttonContainer: Element = this.document.querySelector('.lb-closeContainer');
      if (createElement) {
        buttonContainer.appendChild(newElement);
      } else {
        const oldElement: Element = buttonContainer.getElementsByClassName(downloadButtonFromLightboxClassName)[0];
        if (oldElement != null)
        {
          buttonContainer.removeChild(oldElement);
          buttonContainer.appendChild(newElement);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/photoListSurveyField/photoListSurveyField.component.ts